import { MSBaseUrl, MSEndpoint, MSUrl } from 'src/app/adapters/http/utils/http.utils';

export function getMSApiUrl(base: MSBaseUrl, endpoint: MSEndpoint): MSUrl {
  return `${base}/${endpoint}`;
}
